"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDateValidation = exports.keydownHandler = void 0;
var _react = require("react");
var DIGITS_COUNT = 6;
var DIVIDERS_COUNT = 2;
var keydownHandler = function keydownHandler(input) {
  return function (e) {
    if (!e.ctrlKey) {
      var isNumber = /^[0-9]$/i.test(e.key);
      var isDivider = e.key === '/';
      var isManipulation = ['Delete', 'Backspace', 'ArrowRight', 'ArrowLeft', 'Tab'].includes(e.key);
      var isMaxLength = input.value.length === DIGITS_COUNT + DIVIDERS_COUNT;
      if (!isNumber && !isDivider && !isManipulation || isMaxLength && !isManipulation) {
        e.preventDefault();
      }
    }
  };
};
exports.keydownHandler = keydownHandler;
var useDateValidation = function useDateValidation(inputId) {
  var inputRef = (0, _react.useRef)();
  (0, _react.useLayoutEffect)(function () {
    inputRef.current = document.getElementById(inputId);
    if (inputRef.current) {
      inputRef.current.addEventListener('keydown', keydownHandler(inputRef.current));
    }
    return function () {
      return inputRef.current && inputRef.current.removeEventListener('keydown', keydownHandler(inputRef.current));
    };
  }, [inputId]);
};
exports.useDateValidation = useDateValidation;